import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AddImportantDateDialog = ({ open, onClose, onAdd }) => {
  
  const [formData, setFormData] = useState({
    date: '',
    notes: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.date) {
      console.error('Date is required');
      return;
    }

    try {
      if (typeof onAdd !== 'function') {
        console.error('onAdd prop is not a function');
        return;
      }

      await onAdd({
        date: formData.date,
        notes: formData.notes
      });
      handleClose();
    } catch (error) {
      console.error('Error adding important date:', error);
    }
  };

  const handleClose = () => {
    setFormData({
      date: '',
      notes: ''
    });
    onClose();
  };

  // Format date for form input (needs YYYY-MM-DD format)
  const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toISOString().split('T')[0];
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Add Important Date
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Date"
              type="date"
              value={formatDate(formData.date)}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              required
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              label="Description"
              multiline
              rows={2}
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              fullWidth
              placeholder="Enter description (e.g. Birthday, Anniversary, etc.)"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button 
            type="submit" 
            variant="contained" 
            disabled={!formData.date}
          >
            Add
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddImportantDateDialog;
